import type { ComponentProps } from 'react';
import { cn } from '@/clientOnlyUtils/cn';
import React from 'react';

import type { ButtonPropsSizeType } from '@poseidon/components/Button';

type ContentDividerProps = ComponentProps<'div'> & {
  icon?: React.JSX.Element;
  start?: React.JSX.Element;
  end?: React.JSX.Element;
  align?: 'left' | 'center' | 'right';
  size?: ButtonPropsSizeType;
};
export default function ContentDivider({
  children,
  icon,
  className,
  start,
  end,
  align = 'left',
  size,
  ...props
}: ContentDividerProps) {
  const iconPropsClassName =
    icon?.props && 'className' in (icon.props as Record<string, unknown>)
      ? (icon.props as { className?: string }).className
      : undefined;

  return (
    <div
      className={cn(
        'text-md flex grow items-center gap-2 font-semibold tracking-tight text-slate-600 dark:text-slate-100',
        {
          'text-md': size == 'md',
          'text-base': size == null,
          'text-xs': size === 'sm',
          'text-2xs': size === 'xs',
        },
        className,
      )}
      {...props}>
      {start}
      {align != 'left' && <ContentDividerBar />}
      {icon != null &&
        React.cloneElement(icon, {
          className: cn('size-5 text-slate-600 dark:text-slate-400', iconPropsClassName),
        })}
      {children}
      {align != 'right' && <ContentDividerBar />}
      {end}
    </div>
  );
}

function ContentDividerBar() {
  return <div className="h-[1px] grow bg-slate-300 dark:bg-stone-700" />;
}
